import axios from "axios";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";

export const fetchBag = (payload: Record<string, unknown>) => {
  return axios.post(PKSOFT_URLS.CUSTOMER.BAG, payload).then((r) => r.data);
};

export const proceedOrder = (payload: Record<string, unknown>) =>
  axios.post(PKSOFT_URLS.ORDER.PROCEED, payload).then((r) => r.data);

export const finalizeOrder = (payload: Record<string, unknown>) =>
  axios.post(PKSOFT_URLS.ORDER.SUCCESS, payload).then((r) => r.data);

export const cancelOrder = (payload: Record<string, unknown>) =>
  axios.post(PKSOFT_URLS.CANCEL.ORDER, payload).then((r) => r.data);

export const removeFromCartApi = (variationCode: string, uid: string | number, d: string | number) =>
  // keep existing wrapper to match your removeFromCartAPI
  axios
    .post(`${PKSOFT_URLS.CUSTOMER.CART}/remove`, { variationCode, uid, d })
    .then((r) => r.data);

